import { locale } from '@js/configs/locale'

export default {
    locale: locale,
    messages: {
        en_UK: {
            locale: 'en-GB',
            currency: '£',
            errors: {
                pages: {
                    clientError: {
                        heading: 'Something went wrong',
                        description:
                            'An error ocurred fetching the page response. This is possibly due to a network error. Please try again by refreshing the page.',
                    },
                    notFound: {
                        heading: '404',
                        description: 'The page you are looking for has moved or does not exist.',
                    },
                    internalError: {
                        heading: '500',
                        description:
                            'Something went wrong. Our engineers have been informed and are working on solving the problem.',
                    },
                    unauthorized: {
                        heading: '403',
                        description: 'Unauthorized action.',
                    },
                    unprocessable: {
                        heading: '422',
                        description: 'Unprocessable Entity.',
                    },
                },
            },
        },
    },
}
